import React, { useEffect, useState } from 'react';
import { Platform, StyleSheet, Dimensions, View, StatusBar, TouchableOpacity, Text } from 'react-native';
import { isTablet } from 'react-native-device-info';
import Modal from 'react-native-modal';
import colors from '../resources/colors';
import * as NavigationBar from 'expo-navigation-bar';
import AuthenticationController from '../controllers/AuthenticationController';
import { EventRegister } from 'react-native-event-listeners';
import { format } from 'date-fns';
import DataController from '../controllers/DataController';

const WelcomeModal = ({ trialData, upgraded, loaded }) => {
  const [visible, setVisible] = useState(false);
  const [startDate, setStartDate] = useState(trialData ? new Date(trialData.TrialStartDate) : new Date());
  const [endDate, setEndDate] = useState(trialData ? new Date(trialData.TrialEndDate) : new Date());

  useEffect(() => {
    const changeNavigationBar = async () => {
      if (Platform.OS !== 'android') {
        return;
      }

      if (visible) {
        await NavigationBar.setBackgroundColorAsync('#7D7F80');
      } else {
        await NavigationBar.setBackgroundColorAsync(colors.accentWhite);
      }
    };

    // changeNavigationBar();
  }, [visible]);

  useEffect(() => {
    if (trialData) {
      __DEV__ && console.log(trialData.TrialEndDate)
      setStartDate(new Date(trialData.TrialStartDate));
      setEndDate(new Date(trialData.TrialEndDate));
    }
  }, [trialData]);

  useEffect(() => {
    const getWelcomeOpened = async () => {
      const opened = await AuthenticationController.getWelcomeOpened();
      const hasSubscription = await DataController.getCurrentSubscription();

      console.log('getWelcomeOpened', loaded, opened, upgraded, hasSubscription);

      if (loaded && !opened && !(hasSubscription || upgraded)) {
        setVisible(true);
      } else {
        // await AuthenticationController.setWelcomeOpened();
        setVisible(false);
      }
    };

    getWelcomeOpened();
  }, [loaded]);

  const continueToApp = async () => {
    await AuthenticationController.setWelcomeOpened();
    setVisible(false);
  };

  const closeModal = () => {
    setVisible(false);
  };


  const openSubscriptions = async () => {
    await AuthenticationController.setWelcomeOpened();
    setVisible(false);

    setTimeout(() => {
      EventRegister.emit('welcome/open-accounts');
    }, 1000);
  };

  return (
    <Modal
      isVisible={visible}
      animationIn="fadeIn"
      animationOut="fadeOut"
      onBackdropPress={() => closeModal()}
      onBackButtonPress={() => closeModal()}
      hasBackdrop={true}
      coverScreen={false}
      transparent={false}
      statusBarTranslucent={true}
      deviceHeight={Dimensions.get('screen').height}
      backdropTransitionInTiming={200}
      backdropTransitionOutTiming={0}
      backdropOpacity={0.6}
      backdropColor={colors.grey90}
      style={[styles.webModal,]}>
      <StatusBar translucent backgroundColor="transparent" />
      <View
        style={{
          backgroundColor: colors.accentWhite,
          borderRadius: 10,
          width: Dimensions.get('window').width - 64,
          maxWidth: 350,
          paddingTop: 24,
          paddingBottom: 22,
          paddingHorizontal: 15,
          justifyContent: 'space-between',
        }}>
        <View>
          <Text
            allowFontScaling={false}
            style={{
              fontFamily: 'FiraSans-SemiBold',
              fontSize: 22,
              fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
              fontStyle: 'normal',
              lineHeight: 30,
              letterSpacing: 0.1,
              color: colors.defaultText,
              marginBottom: 8,
            }}>
            {'Welcome to Lectionary'}
          </Text>
          <Text
            allowFontScaling={false}
            style={[styles.text, { marginBottom: 8 }]}>
            {`Please enjoy 30 days of free access to the app. Your free trial begins on ${format(startDate, 'dd/MM/yyyy')} and ends on ${format(endDate, 'dd/MM/yyyy')}.`}
          </Text>
          <Text
            allowFontScaling={false}
            style={[styles.text, { marginBottom: 8 }]}>
            {'After your free trial has ended, you can purchase a subscription option to continue your full access to the app.'}
          </Text>
          <Text
            allowFontScaling={false}
            style={[styles.text, { marginBottom: 20 }]}>
            {'Alternatively, if you hold a Hymns Ancient & Modern account you can sign in below to access the app.'}
          </Text>
        </View>
        <View>
          <TouchableOpacity
            style={{
              width: '100%',
              height: 50,
              borderRadius: 8,
              backgroundColor: colors.primary,
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onPress={() => continueToApp()}>
            <Text
              allowFontScaling={false}
              style={{
                fontFamily: 'FiraSans-SemiBold',
                fontSize: 17,
                fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                fontStyle: 'normal',
                lineHeight: 24,
                letterSpacing: 0.1,
                textAlign: 'center',
                color: colors.accentWhite,
              }}>
              {'Begin free trial'}
            </Text>
          </TouchableOpacity>
          <View
            style={{
              marginVertical: 8,
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <View
              style={{
                height: 2,
                flex: 1,
                backgroundColor: colors.grey40,
              }}
            />
            <Text
              allowFontScaling={false}
              style={{
                fontFamily: 'FiraSans-Regular',
                fontSize: 17,
                fontWeight: 'normal',
                fontStyle: 'normal',
                lineHeight: 26,
                letterSpacing: 0,
                textAlign: 'center',
                color: colors.defaultText,
                marginHorizontal: 8,
              }}>
              {'or'}
            </Text>
            <View
              style={{
                height: 2,
                flex: 1,
                backgroundColor: colors.grey40,
              }}
            />
          </View>
          <TouchableOpacity
            style={{
              width: '100%',
              height: 50,
              borderRadius: 8,
              backgroundColor: colors.primary,
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onPress={() => openSubscriptions()}>
            <Text
              allowFontScaling={false}
              style={{
                fontFamily: 'FiraSans-SemiBold',
                fontSize: 17,
                fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                fontStyle: 'normal',
                lineHeight: 24,
                letterSpacing: 0.1,
                textAlign: 'center',
                color: colors.accentWhite,
              }}>
              {'Sign in and subscription options'}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  webModal: {
    alignItems: undefined,
    justifyContent: 'center',
    height: null,
    overflow: 'hidden',
    borderRadius: 0,
    borderColor: 'rgba(0, 0, 0, 0.1)',
    alignSelf: 'center',
    top: 0,
    margin: 0,
  },
  webContainer: {
    height: '100%',
    backgroundColor: colors.accentWhite,
  },
  webHeight: {
    height: Dimensions.get('window').height,
  },
  text: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 17,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 26,
    letterSpacing: 0,
    color: colors.defaultText,
  },
})

export default WelcomeModal;
